import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import type { blockquoteSCSchema } from './schema';
export type BlockquoteProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof blockquoteSCSchema>>;
export const Blockquote = t0 => {
  const $ = _c(15);
  const {
    props
  } = t0;
  const {
    children,
    sourceLink,
    author,
    authorTitle
  } = props;
  const authorText = authorTitle ? `${authorTitle}${author ? `, ${author}` : ""}` : author;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      margin: "1rem 0",
      padding: ".5rem 1.5rem",
      borderRadius: "4px",
      borderLeft: ".25rem solid #008254"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: "1rem",
      sm: "1.1rem"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = authorText ? "1rem" : 0;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      fontSize: t2,
      marginBottom: t3,
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = renderStructuredContent(children);
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <Box sx={t4}>{t5}</Box>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== authorText || $[10] !== sourceLink) {
    t7 = authorText && <cite>{"\u2014 "}{sourceLink ? <a href={sourceLink} target="_blank" rel="noopener">{authorText}</a> : <Typography>{authorText}</Typography>}</cite>;
    $[9] = authorText;
    $[10] = sourceLink;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <blockquote style={t1}>{t6}{t7}</blockquote>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};